import ReportsMenuPage from "@/app/reportsMenu/pages/ReportsMenuPage.vue";
import DashboardPage from "@/app/dashboard/pages/DashboardPage.vue";
import ReportsPage from "@/app/reports/pages/ReportsPage.vue";

export default [
  {
    path: "/reports",
    component: ReportsMenuPage,
    redirect: "/reports/dashboard",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "dashboard",
        component: DashboardPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "documents",
        component: ReportsPage,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
